import {
  CardStackPlusIcon,
  CheckCircledIcon,
  CircleBackslashIcon,
  CrossCircledIcon,
  DesktopIcon,
  EnvelopeClosedIcon,
  ExclamationTriangleIcon,
  LapTimerIcon,
  LayersIcon,
  ResetIcon,
  StopwatchIcon,
} from "@radix-ui/react-icons";

import {
  PosOrderFulfillmentStatus,
  PosOrderPaymentStatus,
  PosProductStatus,
} from "@/types/prismaTypes";
import { Loader2Icon } from "lucide-react";

export const reservationStatuses = [
  {
    value: "pending",
    label: "Res° pending...",
    icon: LapTimerIcon,
  },
  {
    value: "accepted",
    label: "Res° accepted",
    icon: CheckCircledIcon,
  },
  {
    value: "rejected",
    label: "Res° rejected",
    icon: CircleBackslashIcon,
  },
  {
    value: "invited",
    label: "Invited",
    icon: EnvelopeClosedIcon,
  },
];

export const paymentStatuses = [
  {
    value: "pending",
    label: "Payment pending...",
    icon: LapTimerIcon,
  },
  {
    value: "gateway_success",
    label: "Payment by card successful",
    icon: CheckCircledIcon,
  },
  {
    value: "cash_success",
    label: "Payment received Cash",
    icon: CheckCircledIcon,
  },
  {
    value: "free",
    label: "Free ticket",
    icon: CheckCircledIcon,
  },
  {
    value: "gateway_failed",
    label: "Payment by card failed",
    icon: ExclamationTriangleIcon,
  },
  {
    value: "gateway_expired",
    label: "Payment by card expired",
    icon: StopwatchIcon,
  },
  {
    value: "gateway_cancelled",
    label: "Payment by card Cancelled",
    icon: CrossCircledIcon,
  },
  {
    value: "partially_paid_at_door",
    label: "Partially paid at door",
    icon: Loader2Icon,
  },
  {
    value: "awaiting_payment_at_door",
    label: "Awaiting payment at door",
    icon: StopwatchIcon,
  },
];

export const paidByOptions = [
  {
    value: "DASHBOARD",
    label: "Dashboard",
    icon: DesktopIcon,
  },
  {
    value: "GATEWAY",
    label: "Payment Gateway",
    icon: LayersIcon,
  },
];

export const productStatuses = [
  {
    value: PosProductStatus.ENABLED,
    label: "Product Enabled",
    icon: CheckCircledIcon,
    className: "bg-green-300",
  },
  {
    value: PosProductStatus.DISABLED,
    label: "Product Disabled",
    icon: CircleBackslashIcon,
    className: "bg-green-300",
  },
];

export const posProductPublicAvailabilityStatuses = [
  {
    value: true,
    label: "Product Publicly Visible",
    icon: CheckCircledIcon,
    className: "bg-green-300",
  },
  {
    value: false,
    label: "Product Publicly Hidden",
    icon: CircleBackslashIcon,
    className: "bg-red-300",
  },
];

// New arrays for PosOrderPaymentStatus and PosOrderFulfillmentStatus
export const posOrderPaymentStatuses = [
  {
    value: PosOrderPaymentStatus.PENDING,
    label: "Payment pending...",
    icon: LapTimerIcon,
  },
  {
    value: PosOrderPaymentStatus.PARTIALLY_PAID,
    label: "Partially paid",
    icon: Loader2Icon,
  },
  {
    value: PosOrderPaymentStatus.PAID,
    label: "Payment done",
    icon: CheckCircledIcon,
  },
  {
    value: PosOrderPaymentStatus.REFUNDED,
    label: "Payment refunded",
    icon: ResetIcon,
  },
  {
    value: PosOrderPaymentStatus.CANCELLED,
    label: "Payment cancelled",
    description: "Payment cancelled",
    icon: CrossCircledIcon,
  },
];

export const posOrderFulfillmentStatuses = [
  {
    value: PosOrderFulfillmentStatus.CREATED,
    label: "Order Created",
    description: "Your order has been created.",
    icon: CardStackPlusIcon,
  },
  {
    value: PosOrderFulfillmentStatus.READY,
    label: "Order Ready",
    description: "Your order is ready.",
    icon: CheckCircledIcon,
  },
  {
    value: PosOrderFulfillmentStatus.CANCELLED,
    label: "Order Cancelled",
    description: "Your order has been cancelled.",
    icon: CrossCircledIcon,
  },
];
